import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FaqService {

  faqData: any = [];
  constructor(private http: HttpClient) {
    this.getFaq();
  }

  getFaq() {
    this.http.get(`${environment.apiUrl}/faq`).subscribe({
      next: data => {
        this.faqData = data;
      },
      error: err => {}
    })
  }
}
